<template>
  <div class="box">
    <!-- <img class="box_logo" src="../../assets/image/logo-200x50.png" alt=""> -->
    <div class="container">
      <h1>Terms and conditions</h1>
      <p style="font-size: 14px;"><strong>DATED: 8TH APRIL 2024</strong></p>
      <ul class="ul_1">
        <li>
          <p><strong>GENERAL</strong></p>
          <ul class="ul_2">
            <li>The Game is owned and operated by Myte Games (“Company”).</li>
            <li>These Terms and Conditions form a binding legal agreement between you and us and apply to your use of any of our Games or our Platform in any way, through any electronic device (web, mobile, tablet or any other device).</li>
            <li>PLEASE NOTE THAT THESE TERMS AND CONDITIONS INCLUDE A PROVISION WAIVING THE RIGHT TO PURSUE ANY CLASS, GROUP OR REPRESENTATIVE CLAIM AND REQUIRING YOU TO PURSUE PAST, PENDING, AND FUTURE DISPUTES BETWEEN YOU AND US THROUGH INDIVIDUAL ARBITRATION UNLESS YOU OPT OUT WITHIN THE SPECIFIED TIME FRAME.</li>
            <li>THE GAMES AND PLATFORM DO NOT OFFER REAL MONEY GAMBLING, AND NO ACTUAL MONEY IS REQUIRED TO PLAY. ONLY PLAYERS IN THE UNITED STATES (EXCLUDNG THE STATES OF IDAHO AND WASHINGTON) AND CANADA (EXCLUDING QUEBEC) ARE ELIGIBLE TO ENTER THE SWEEPSTAKES.</li>
          </ul>
        </li>
        <li>
          <p><strong>STATEMENT</strong></p>
          <ul class="ul_2">
            <li>
              You declare and warrant that:
              <ul class="ul_3">
                <li>you are over 18 years of age or such higher minimum legal age of majority as stipulated in the jurisdiction of your residence and are, under the laws applicable to you, legally allowed to participate in the Games offered on the Platform;</li>
                <li>YOU DO NOT RESIDE IN OR ACCESS THE PLATFORM FROM THE EXCLUDED TERRITORIES</li>
                <li>you participate in the Games strictly in your personal capacity for recreational and entertainment purposes only;</li>
                <li>you participate in the Games on your own behalf and not on the behalf of any other person;</li>
                <li>all information that you provide to us during the term of validity of these Terms and Conditions is true, complete and correct, and you will immediately notify us of any change to such information;</li>
                <li>you will not be involved in any fraudulent, collusive, fixing or other unlawful activity in relation to your or third parties’ participation in any of the Games and you will not use any software-assisted methods or techniques (including but not limited to bots designed to play automatically) or hardware devices for your participation in any of the Games. We reserve the right to invalidate any participation in the event of such behaviour; </li>
              </ul>
            </li>
            <li>b.It is a Player’s responsibility to ensure that their Participation is lawful in their jurisdiction. Any person who is knowingly in breach of clause 2, including any attempt to circumvent this restriction, for example, by using a VPN, proxy or similar service that masks or manipulates the identification of your real location, or by otherwise providing false or misleading information regarding your location or place of residence, or by Participating from an Excluded Territory or through a third party or on behalf of a third party located in an Excluded Territory, is in breach of these Terms and Conditions. You may be committing fraud and may be subject to criminal prosecution.</li>
          </ul>
        </li>
        <li>
          <p><strong>LICENCE</strong></p>
          <ul class="ul_2">
            <li>Subject to your agreement and continuing compliance with these Terms and Conditions, Company grants you a personal, non-exclusive, non-transferable, non-sublicensable, revocable, limited licence to access and use the Platformand the Content, through a supported Web browser or mobile device, solely for your personal, private entertainment and no other reason.</li>
            <li>Company grants you a personal, non-exclusive, nontransferable, non-sublicensable, revocable, limited licence to use the avatars available on the Platform. </li>
            <li>PLEASE NOTE THAT COMPANY MAY ADD OR REMOVE AVATARS AT ITS SOLE DISCRETION AND WITH NO FURTHER NOTICE TO YOU. THE PURCHASE OF AN AVATAR IS THE PURCHASE OF A LICENCE TO USE THAT AVATAR FOR AS LONG AS IT IS AVAILABLE ON THE PLATFORM.</li>
            <li>These Terms and Conditions do not grant you any right, title or interest in the Platform or Content.</li>
            <li>You acknowledge and agree that your licence to use the Platform is limited by these Terms and Conditions and if you do not agree to, or act in contravention of, these Terms and Conditions, your licence to use the Platform (including the Games and Content) may be immediately terminated.</li>
            <li>Where the Platform or any Game is deemed to be illegal under the laws of the jurisdiction in which you reside or are situated, you will not be granted any licence to, and must refrain from accessing, the Platform or relevant Game.</li>
          </ul>
        </li>
        <li>
          <p><strong>ACCOUNT</strong></p>
          <ul class="ul_2">
            <li>You are allowed to have only one Customer Account, including any Inactive Account on the Platform. If you attempt to open more than one Customer Account, all accounts you have opened or try to open may be suspended or closed.</li>
            <li>You must notify us immediately if you notice that you have more than one registered Customer Account, whether active or not on any one Platform. DO NOT CREATE A NEW CUSTOMER ACCOUNT IF YOU WISH TO CHANGE YOUR EMAIL, ADDRESS OR SURNAME.</li>
            <li>You are required to keep your registration details up to date at all times. If you change your address, email, phone number or any other contact details or personal information contact Customer Support via this form and choose ‘Request Support’ from the drop down menu in order to update your details. The name that you provide to us at registration must be identical to that listed on your government issued identification.Security and Responsibility of Your Customer Account</li>
            <li>It is your sole and exclusive responsibility to ensure that your Customer Account login details and any Payment Mediums are kept secure and are only accessible by you. You accept full responsibility for any unauthorised use of your Customer Account and any activity linked to your Customer Account, including by a minor (which in all events is prohibited).</li>
            <li>You must not share your Customer Account or password with another person, let anyone else access or use your Customer Account or do any other thing that may jeopardise the security of your Customer Account.</li>
            <li>If you become aware of, or reasonably suspect that security in your Customer Account has been compromised, including loss, theft or unauthorised disclosure of your password and Customer Account details, you must notify us immediately.</li>
            <li>You are solely responsible for anything that happens through your Customer Account, whether or not you undertook those actions. You acknowledge that your Customer Account may be terminated if someone else uses it and engages in any activity that breaches these Terms and Conditions or is otherwise illegal.</li>
            <li>We are not responsible for any abuse or misuse of your Customer Account by third parties due to your disclosure of your login details to any third party, whether such disclosure is intentional or accidental, active or passive.</li>
          </ul>
        </li>
        <li>
          <p><strong>FRAUDULENT CONDUCT</strong></p>
          <ul class="ul_2">
            <li>
              You will not, directly or indirectly:
              <ul>
                <li>hack into any part of the Games or Platform through password mining, phishing, or any other means;</li>
                <li>attempt to modify, reverse engineer, or reverse-assemble any part of the Games or Platform;</li>
                <li>knowingly introduce viruses, Trojans, worms, logic bombs, spyware, malware, or other similar material;</li>
                <li>circumvent the structure, presentation or navigational function of any Game so as to obtain information that Company has chosen not to make publicly available on the Platform; or</li>
                <li>engage in any form of cheating or collusion.</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <p><strong>INTELLECTUAL PROPERTY</strong></p>
          <ul class="ul_2">
            <li>The computer software, the computer graphics, the Platform and the user interface that we make available to you is owned by, or licensed to, Company or its associates and protected by relevant intellectual property laws. You may only use the software for your own personal, recreational uses in accordance with all rules, terms and conditions we have established (including these Terms and Conditions and the Sweeps Rules) and in accordance with all applicable laws, rules and regulations.</li>
            <li>You acknowledge that Company is the proprietor or authorized licensee of all intellectual property in relation to any Content.</li>
            <li>Your use of the Games and Platform does not provide you with any intellectual property rights in the Content, Games or Platform.</li>
            <li>You grant us, and represent and warrant that you have the right to grant us, an irrevocable, perpetual, worldwide, nonexclusive, royalty-free licence to use in whatever way we see fit, any information, images, videos, comments, messages, music or profiles you publish or upload to any website or social media page controlled and operated by Company.</li>
            <li>You must not reproduce or modify the Content in any way, including by removing any copyright or trade mark notice.</li>
            <li>All trade marks and logos displayed in the Games and Platform are the property of their respective owners and are protected by applicable trade mark and copyright laws.</li>
          </ul>
        </li>
        <li>
          <p><strong>DISRUPTIONS</strong></p>
          <ul class="ul_2">
            <li>The Platform is provided on an “as is” basis and to the fullest extent permitted by law, we make no warranty or representation, whether express or implied, in relation to the satisfactory quality, fitness for purpose, completeness or accuracy of the Platform (including the Games and Content).</li>
            <li>Company is not liable for any downtime, server disruptions, lagging, or any technical or political disturbance to Game play, nor attempts by you to Participate by methods, means or ways not intended by us.</li>
            <li>Company accepts no liability for any damages or losses which are deemed or alleged to have arisen out of or in connection with any Platform or its Content including, without limitation, delays or interruptions in operation or transmission, loss or corruption of data, communication or lines failure, any person’s misuse of a Platform or its Content or any errors or omissions in 8.4. In the event of a Platform system malfunction all Game play on that Platform is void.</li>
            <li>Company reserves the right to suspend, modify, remove or add Content to the Platform at its sole discretion with immediate effect and without notice to you. We will not be liable to you for any loss suffered as a result of any changes made or for any modification or suspension of or discontinuance of the Platform (including any Game thereon) and you will have no claims against Company in such regard.</li>
            <li>We may temporarily suspend the whole or any part of the Platform for any reason at our sole discretion. We may, but will not be obliged to, give you as much notice as is reasonably practicable of such suspension. We will restore the Platform, as soon as is reasonably practicable, after such temporary suspension.</li>
            <li>We Both Agree to Arbitrate. By agreeing to these Terms and Conditions, and to the extent permitted by applicable law, both you and Company agree to resolve any Disputes – including any Dispute concerning the enforceability, validity, scope or severability of this agreement to arbitrate  through final and binding arbitration.</li>
          </ul>
        </li>
        <li>
          <p><strong>MARKETING COMMUNICATIONS</strong></p>
          <ul class="ul_2">
            <li>You consent to receive marketing communications from Company in respect of its offerings by way of email, post, SMS and telephone notifications, any of which you may unsubscribe from at any.</li>
          </ul>
        </li>
        <li>
          <p><strong>INDEMNITY AND LIMITATION OF LIABILITY</strong></p>
          <ul class="ul_2">
            <li>YOU AGREE TO INDEMNIFY AND HOLD HARMLESS US AND OUR AFFILIATES, AND OUR RESPECTIVE PARTNERS, DIRECTORS, OFFICERS, EMPLOYEES, SHAREHOLDERS, SUBCONTRACTORS, LICENSORS, SUPPLIERS AND AGENTS AGAINST ANY AND ALL COSTS, EXPENSES, LIABILITIES AND DAMAGES (WHETHER DIRECT, INDIRECT, SPECIAL, CONSEQUENTIAL, EXEMPLARY OR PUNITIVE OR OTHER) ARISING FROM ANY PARTICIPATION BY YOU, INCLUDING WITHOUT LIMITATION.</li>
            <li>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES WHATEVER WILL WE OR OUR AFFILIATES, OR OUR RESPECTIVE PARTNERS, OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS, AGENTS, LICENSORS, SUBCONTRACTORS AND SUPPLIERS, BE RESPONSIBLE OR LIABLE TO YOU OR TO ANY OTHER ENTITY, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, UNDER ANY LEGAL THEORY, WHETHER CONTRACT, TORT OR OTHERWISE, FOR ANY INDIRECT, INCIDENTAL , CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE DAMAGES, INCLUDING ANY LOST PROFITS AND LOST BUSINESS OPPORTUNITIES, BUSINESS INTERRUPTION, LOST REVENUE, INCOME, GOODWILL, USE OF DATA OR OTHER INTANGIBLE LOSSES, IN EACH CASE THAT RESULTS FROM OR RELATESIN ANY MANNER TO YOUR PARTICIPATION OR ANY OTHER ACT OR OMISSION BY US.</li>
          </ul>
        </li>
        <li>
          <p><strong>MISCELLANEOUS</strong></p>
          <ul class="ul_2">
            <li>These Terms and Conditions constitute the entire agreement between you and us with respect to your Participation and, save in the case of fraud, supersede all prior or contemporaneous communications and proposals, whether electronic, oral or written, between you and us with respect to your Participation.</li>
            <li>Company reserves the right to amend these Terms and Conditions, or to implement or amend any procedures, at any time. Any amendments will be published on the Platform and such changes will be binding and effective immediately.</li>
            <li>Whenever we amend these Terms and Conditions in a way that would limit your current rights or which may be to your detriment, we will notify you upon your next visit to the Platform and you will be required to re-confirm your acceptance prior to playing any Games. If you do not agree to the amended Terms and Conditions, you must stop using the Platform.</li>
            <li>Company will not be liable or responsible for any failure to perform, or delay in performance of, any of our obligations under these Terms and Conditions that is caused by events outside of our reasonable control.</li>
            <li>If any of the Terms and Conditions are determined by any competent authority to be invalid, unlawful or unenforceable to any extent, such term, condition or provision will, to that extent, be severed from these Terms and Conditions. All remaining terms, conditions and provisions will continue to be valid to the fullest extent permitted by law. In such cases, the part deemed invalid or unenforceable will be amended in a manner consistent with the applicable law to reflect, as closely as possible, the original import of the invalid or unenforceable provision.</li>
            <li>We consider these Terms and Conditions to be open and fair. </li>
            <li>The Terms and Conditions prevail over any communication via email or chat.</li>
            <li>All correspondence between you and us may be recorded.</li>
            <li>These Terms and Conditions are personal to you, and are not assignable, transferable or sub-licensable by you except with our prior written consent. We reserve the right to assign, transfer or delegate any of our rights and obligations hereunder to any third party without notice to you.</li>
            <li>These Terms and Conditions may be published in several languages for information purposes and ease of access by players but will all reflect the same principles. It is only the English version that is the legal basis of the relationship between you and us and in case of any discrepancy between a non-English version and the English version of these Terms and Conditions, the English version will prevail.</li>
          </ul>
        </li>
      </ul>
    </div>
    <FooterPage2></FooterPage2>
  </div>
</template>

<script>
import FooterPage2 from "../../components/footerPage2/index"
export default {
  name: 'TermsAndConditions',
  components:{
    FooterPage2,
  }
}
</script>

<style lang="scss" scoped>
.box {
  background: #eaf2ff;
  width: 100%;
  padding-bottom: .4167rem;
  h1 {
    text-align: center;
    padding: .4167rem;
    color: #00204c;
  }
}

.container {
  width: 6.7708rem;
  margin: 0 auto;
  .up_date{
    margin-bottom: .2604rem;
  }
  span{
    font-size: 14px;
    line-height: .1563rem;
  }
  .tit{
    display: block;
    margin: .1042rem 0;
  }
}

.ul_1 {
  margin-top: .2604rem;
  list-style-type: upper-alpha;
  margin-left: -1em;
  line-height: .1823rem;
  font-size: 20px;
  color: #00204c;
      li{
        color: #00204c;
      }
  .ul_2 {
    font-size: 14px;
    list-style-type: lower-alpha;
    text-align: left;
    line-height: .1302rem;
    padding-left: .026rem;
    margin: .0521rem 0;
    color: #00204c;
      li{
        color: #00204c;
      }
    .ul_3{
      font-size: 14px;
      list-style-type: disc;
      text-align: left;
      line-height: .1302rem;
      padding-left: .0521rem;
      margin: .0521rem 0;
      li{
        color: #00204c;
      }
    }
  }
}
.box_logo{
  width: 200px;
  height: auto;
  position: relative;
  left: 2.0313rem;
  top: .5729rem;
}
@media (max-width: 1000px) {
  .box_logo{
    width: 80px;
    height: auto;
    position: relative;
    left: .1042rem;
    top: 30px;
  }
  .container{
    h1{
      font-size: 24px;
    }
    .tit{
      font-size: 0.01em;
      line-height: 30px;
    }
}
  .ul_1 {
    font-size: 10px;
    strong{
      line-height:20px;
    }
    .ul_2{
      line-height: 30px;
      padding-left: .0521rem;
      .ul_3{
        line-height: 30px;
        padding-left: .0521rem;
      }
    }
  }
}

</style>